import { task } from 'ember-concurrency';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Controller from '@ember/controller';
import { bomSourceDropdownOptions } from 'eflex/constants/bom-source-types';
import { tracked } from '@glimmer/tracking';
import { waitFor } from '@ember/test-waiters';
import { PERMISSION_NAMES } from 'eflex/constants/user-permissions';

export default class BomSourcesIndexController extends Controller {
  @tracked selectedBomSource;
  @tracked showNewModal = false;
  @tracked showDeleteModal = false;
  @tracked selectedNewType = bomSourceDropdownOptions[0];

  bomSourceDropdownOptions = bomSourceDropdownOptions;
  permission = PERMISSION_NAMES.bomSources;

  @service bomSourceRepo;
  @service router;
  @service currentUser;

  get hasPermission() {
    return this.currentUser.user.hasPermission(this.permission);
  }

  deleteSource = task(waitFor(async () => {
    await this.bomSourceRepo.delete.perform(this.selectedBomSource);
    this.showDeleteModal = false;
    this.selectedBomSource = null;
  }));

  @action
  createSource() {
    const bomSource = this.bomSourceRepo.create(this.selectedNewType.id);

    Object.assign(this, {
      showNewModal: false,
      selectedNewType: bomSourceDropdownOptions[0],
    });
    this.router.transitionTo('bomSources.bomSource', bomSource);
  }

  @action
  toggleDeleteModal(source) {
    Object.assign(this, {
      showDeleteModal: Boolean(source),
      selectedBomSource: source,
    });
  }
}
